import {AuthService} from '../services/auth.service';

class AuthorizedController implements ng.IComponentController {
    static $inject = ['AuthService', 'Restangular'];
    constructor(private authService: AuthService, private Restangular: Restangular.IService ) {
       
    }

    public $onInit = () => {
        this.authService.authorizeCallback();
        this.authService.setTokenHeader();
    }
}

export const authorized = {
    controller : AuthorizedController,
    template : require('./index.html')
}; 


// WEBPACK FOOTER //
// ./src/app/authorization/authorized/index.ts